import { ROUTE_LIVE_CASINO } from '../router/constants';

const headerLinks = {
	sportsbook: '/sportsbook',
	casino: '/casino',
	'live-casino': ROUTE_LIVE_CASINO,
	virtuals: '/sportsbook',
	'we-spin': '/we-spin'
} as const;

type Products = keyof typeof headerLinks;

const getHeaderLink = (link: Products) => {
	return headerLinks[link] || '';
};
export default getHeaderLink;
